import React, { PropsWithChildren } from 'react'
import Head from 'next/head'
import { Link } from 'react-router-dom'
import { Box } from '@hub/box'
import { CoreContainer } from '@hub/core-container'
import { H2 } from '@hub/heading'
import { UniversalFooter } from '../../components/universal-footer'
import CVPStrip from '../cvp-strip'
import { UniversalHeaderOptions, useUniversalHeader } from '../universal-header'
import { MetaData } from '../../../types/meta-data'

export interface ILayoutProps {
  country: 'Australia' | 'New Zealand'
  header: UniversalHeaderOptions | null
  centre: React.ComponentProps<typeof UniversalFooter>['centre'] | undefined
  metaData?: MetaData
  pageTitle?: string
  showCVPStrip?: boolean
}

export default function Layout({
  country,
  centre,
  header,
  metaData,
  pageTitle,
  showCVPStrip = true,
  children,
}: PropsWithChildren<ILayoutProps>): JSX.Element {
  const [Header, setHeaderNavigationPath] = useUniversalHeader(header)

  return (
    <>
      <Head>
        {metaData?.title && <title>{metaData.title}</title>}
        {metaData?.description && (
          <meta
            key="description"
            name="description"
            content={metaData.description}
          />
        )}
        {metaData?.canonical && (
          <link key="canonical" rel="canonical" href={metaData.canonical} />
        )}
      </Head>
      {showCVPStrip && <CVPStrip />}
      <Header />
      {pageTitle && (
        <CoreContainer>
          <H2 sx={{ marginBottom: 'spacing-sm' }}>{pageTitle}</H2>
        </CoreContainer>
      )}
      {children}
      <Box sx={{ marginTop: ['spacing-4xl', null, 'spacing-5xl'] }}>
        <UniversalFooter
          Link={Link}
          centre={centre}
          country={country}
          onFindACentre={() => setHeaderNavigationPath(['find-a-centre'])}
        />
      </Box>
    </>
  )
}
